import io from "socket.io-client";
export default {
  data() {
    return {
      socket: null,
      socketioURL: 'http://localhost:6357',
    }
  },
  async mounted() {
    // Connect Socket
    this.socket = io(this.socketioURL, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
    });
    this.socket.on("connect", () => {
      this.$store.commit("socket/setSocketConnected", { socketConnected: this.socket.connected });
    });
    this.socket.on("data", (data) => {
      this.$store.commit("socket/setEventData", data);
    });
    this.socket.on("disconnect", (reason) => {
      this.$store.commit("socket/setEventData", null);
      this.$store.commit("socket/setSocketConnected", { socketConnected: false });
    });
    this.socket.on("connect_error", (error) => {
      this.$store.commit("socket/setEventData", null);
      this.$store.commit("socket/setSocketConnected", { socketConnected: false });
      this.$store.commit("socket/setErrorConnect", { errorConnect: error });
    });
  },
  methods: {
    emitEvent(args) {
      /* Emit events */
      this.socket.emit("data", args, (response) => {
        /* Handle response, if any */
        // console.log("response: ", response.message);
      });
    },
  },
  beforeDestroy() {
    // For a specific event
    this.socket.removeAllListeners(['data'])
    // For all events
    this.socket.removeAllListeners();
    // Disconnect socket
    this.socket.disconnect()
  },
}